const positiveInteger = (value) => Number.isInteger(Number(value)) && Number(value) > 0;

export function localDateTimeInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const pad = (part) => String(part).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function toWaitlistDraft(request) {
  return {
    clientId: request?.client?.id || '',
    treatmentProductId: request?.treatment?.id || '',
    partySize: request?.partySize || 1,
    desiredStartAt: localDateTimeInput(request?.desiredStartAt),
    desiredEndAt: localDateTimeInput(request?.desiredEndAt),
    preferredOperatorId: request?.preferredOperator?.id || '',
  };
}

export function buildWaitlistPayload(draft) {
  if (!positiveInteger(draft.clientId) || !positiveInteger(draft.treatmentProductId)
    || (draft.preferredOperatorId !== '' && !positiveInteger(draft.preferredOperatorId))) throw new Error('invalidReferences');
  if (!positiveInteger(draft.partySize) || Number(draft.partySize) > 100) throw new Error('invalidPartySize');
  const start = new Date(draft.desiredStartAt);
  const end = new Date(draft.desiredEndAt);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || end <= start) throw new Error('invalidInterval');
  return {
    clientId: Number(draft.clientId),
    treatmentProductId: Number(draft.treatmentProductId),
    partySize: Number(draft.partySize),
    desiredStartAt: start.toISOString(),
    desiredEndAt: end.toISOString(),
    preferredOperatorId: draft.preferredOperatorId === '' ? null : Number(draft.preferredOperatorId),
  };
}

export function offerSecondsRemaining(expiresAt, now = Date.now()) {
  const expires = new Date(expiresAt).getTime();
  return Number.isFinite(expires) ? Math.max(0, Math.ceil((expires - now) / 1000)) : 0;
}
